import { create } from 'zustand';

interface SidebarStore {
  isOpen: boolean;
  isCollapsed: boolean;
  open: () => void;
  close: () => void;
  setCollapsed: (isCollapsed: boolean) => void;
  toggleCollapse: () => void;
  toggleOpen: () => void;
}

export const useTappSidebar = create<SidebarStore>()((set, get) => ({
  // TODO: Check user agent in case of next.js ?
  isOpen: window != null ? window.innerWidth >= 768 : true,
  // TODO: Check user agent in case of next.js ?
  isCollapsed: window != null ? window.innerWidth >= 768 && window.innerWidth < 1024 : false,
  // isOpen: true,
  // isCollapsed: false,
  open: () => {
    set({
      isOpen: true,
      isCollapsed: false,
    });
  },
  close: () => {
    set({
      isOpen: false,
    });
  },
  toggleOpen: () => {
    set((state) => ({
      isOpen: !state.isOpen,
      isCollapsed: false,
    }));
  },
  setCollapsed: (isCollapsed: boolean) => {
    set({
      isOpen: true,
      isCollapsed,
    });
  },
  toggleCollapse: () => {
    set((state) => ({
      isOpen: true,
      isCollapsed: !state.isCollapsed,
    }));
  },
}));
